import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitLead = async (data) => (await axios.post(`${API}/leads`, data)).data;
export const submitAudit = async (data) => (await axios.post(`${API}/audits`, data)).data;
export const getAudit = async (id) => (await axios.get(`${API}/audits/${id}`)).data;
